import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchRecentOffers'
})
export class SearchRecentOffersPipe implements PipeTransform {

  transform(recentOffers: any, searchText: string) {
    if (!searchText) {
      return recentOffers; // Return the original array if search text is empty
    }

    searchText = searchText.toLowerCase(); // Convert the search text to lowercase for case-insensitive comparison

    return recentOffers.filter((vehicles: any) =>
      (vehicles.make_name && vehicles.make_name.toLowerCase().includes(searchText))||
      (vehicles.model_name && vehicles.model_name.toLowerCase().includes(searchText))||
      (vehicles.chassis_no && vehicles.chassis_no.toLowerCase().includes(searchText))||
      (vehicles.customer_name && vehicles.customer_name.toLowerCase().includes(searchText))||
      (vehicles.customer_phone_no && vehicles.customer_phone_no.toLowerCase().includes(searchText))||
      (vehicles.sales_rep_name && vehicles.sales_rep_name.toLowerCase().includes(searchText))
    );
  }

}
